import type { LandingPageContent } from '../types'

export const ENCONTRAR_INSTALADOR_FOTOVOLTAICO: LandingPageContent = {
  slug: 'encontrar-instalador-fotovoltaico',
  lang: 'es',
  topicId: 'pv-installateur-finden',
  title: 'Encontrar instalador fotovoltaico – empresas verificadas',
  metaDescription:
    'Encuentre instaladores fotovoltaicos para su proyecto. Las empresas ofertan sobre su ' +
    'solicitud anónima - usted elige quién puede contactarle.',
  keywords: [
    'encontrar instalador fotovoltaico',
    'buscar instalador placas solares',
    'empresa instaladora fotovoltaica',
    'encontrar empresa fotovoltaica',
    'instalador fotovoltaico patrimonio protegido',
  ],
  eyebrow: 'Encontrar instalador',
  h1: 'Encontrar el instalador fotovoltaico adecuado',
  intro:
    'En lugar de escribir a instaladores uno por uno y esperar respuesta, en Roofora se invierte el ' +
    'proceso: su solicitud llega a varias empresas instaladoras a la vez, que presentan un presupuesto ' +
    'por iniciativa propia.',
  sections: [
    { type: 'heading', text: 'Cómo encontrar un instalador en Roofora' },
    {
      type: 'paragraph',
      text:
        'Usted crea una solicitud anónima con los datos del tejado y su consumo. Las empresas ' +
        'instaladoras y electricistas de su región ven esta solicitud y pueden presentar un ' +
        'presupuesto gratis - sin que usted tenga que investigar o contactar con empresas una por una.',
    },
    { type: 'heading', text: 'Qué caracteriza a un buen instalador fotovoltaico' },
    {
      type: 'list',
      items: [
        'Presupuesto comprensible y desglosado, no un precio a tanto alzado',
        'Valoraciones de proyectos ya finalizados',
        'Condiciones claras de garantía y servicio',
        'Experiencia con su tipo de tejado y de instalación',
      ],
    },
    { type: 'heading', text: 'Disponibilidad regional de empresas instaladoras' },
    {
      type: 'paragraph',
      text:
        'Cuántas empresas oferten sobre su solicitud depende de su región. Puede ver en todo momento ' +
        'cuántos presupuestos hay ya, y esperar con calma hasta tener suficientes puntos de ' +
        'comparación.',
    },
    { type: 'heading', text: 'Para empresas instaladoras: encuentre proyectos en su región' },
    {
      type: 'paragraph',
      text:
        'Los instaladores y electricistas ven solicitudes anónimas de su región - con datos del tejado ' +
        'y consumo, pero sin datos de contacto. Presentar un presupuesto es gratuito y sin compromiso.',
    },
  ],
  faq: [
    {
      q: '¿Tengo que investigar yo mismo qué empresas instaladoras existen?',
      a: 'No - usted crea una solicitud y las empresas adecuadas de su región ofertan por iniciativa propia.',
    },
    {
      q: '¿Cómo sé si un instalador es de confianza?',
      a: 'Puede ver el perfil de cada empresa con sus valoraciones antes de decidir si le autoriza a contactarle, y comparar varios presupuestos antes de decidirse.',
    },
    {
      q: '¿También puedo encontrar un instalador con experiencia en edificios protegidos (patrimonio)?',
      a: 'Sí - indique el estado de protección patrimonial de su edificio al solicitar. Las empresas con experiencia en este tipo de proyectos pueden postularse específicamente, sin que tenga que buscarlas usted mismo.',
    },
  ],
  primaryCta: { label: 'Crear solicitud y encontrar instaladores', action: 'customer' },
  secondaryCta: { label: 'Registrarse como empresa instaladora', action: 'craftsman' },
  relatedLinks: [
    { label: 'Cómo funciona la comparación de presupuestos', href: '/comparar-presupuestos-fotovoltaicos' },
    { label: 'Solicitar presupuesto fotovoltaico', href: '/solicitar-presupuesto-fotovoltaico' },
    { label: 'Coste de una instalación fotovoltaica', href: '/coste-instalacion-fotovoltaica' },
    { label: '¿Solo necesita el montaje en el tejado?', href: '/montaje-paneles-solares' },
    { label: '¿Solo necesita la instalación eléctrica?', href: '/instalacion-electrica-fotovoltaica' },
  ],
}
